/**
 * @file コンポーネント：フル動画ページ症例データの言語プルダウン スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledContent = styled.nav`
    padding-right: 0;
`;

export const StyledContentIcon = styled.span`
    margin-right: 8px;
    color: #929496;
    font-size: 20px;
    line-height: 20px;
`;
